// 224EVER — Sticky transparent header
(function() {
  var header = document.querySelector('.pageheader');
  if (!header) return;

  // Set initial header height CSS var so body padding is exact
  function setHeaderHeight() {
    var h = document.querySelector('.section-header');
    if (h) {
      var height = h.offsetHeight + 'px';
      document.documentElement.style.setProperty('--theme-header-height', height);
      document.body.style.paddingTop = height;
      // Pull hero back up
      var hero = document.querySelector('.shopify-section:first-child .section-slideshow');
      if (hero) hero.style.marginTop = '-' + height;
    }
  }

  function onScroll() {
    if (window.scrollY > 10) {
      header.classList.add('pageheader--sticky');
    } else {
      header.classList.remove('pageheader--sticky');
    }
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', setHeaderHeight);

  // Run after fonts/layout settle
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      setHeaderHeight();
      onScroll();
    });
  } else {
    setHeaderHeight();
    onScroll();
  }
})();
